var innerRemote;
function attachRemote (resolve) {
	if(__webpack_require__.m[8991]) {
		innerRemote = __webpack_require__(8991);
	}
	var gs = __webpack_require__.g || globalThis
	gs["host"] = innerRemote
	if(resolve) resolve(innerRemote);
	return innerRemote;
};
__webpack_require__.federation.attachRemote = attachRemote;
attachRemote();